module.exports = __webpack_public_path__ + "static/media/money-bag.785dd463.png";